import React, { useState, useEffect } from "react";

import { LoyaltyTwoTone } from "@material-ui/icons";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import TextField from "@material-ui/core/TextField";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import axios from "axios";

import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker,
} from "@material-ui/pickers";
import {get_cookies, isLoggedIn} from "../../../components/Cookies/Cookies";
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';
import LoadingModal from "../../../components/Modal/LoadingModal";
import MessageBox from "../../../components/MessageBox/MessageBox";
import {  useParams, useHistory, NavLink } from "react-router-dom";
import Slide from '@material-ui/core/Slide';
import { Breadcrumbs, Typography } from "@material-ui/core";

const useStyles = makeStyles({
	field: {
		width: "100%",
		marginBottom: "1rem",
	},
	autoComplete: {
		width: "100%",
		marginTop: "0",
		marginBottom: "0.5rem",
	},
	date: {
		width: "100%",
		marginBottom: "1rem",
	},
	buttonContainer: {
		textAlign: "right",
	},
	card: {
		marginBottom: "1rem",
	},
	cardHeader: {
		borderBottom: "1px solid #4aba4a",
		padding: "1.3rem 24px 2rem 24px",
	},
	title: {
		marginTop: "0",
		color: "#339933",
		fontWeight: "700",
		fontSize: "1.1rem",
	},
	subTitle: {
		fontSize: "0.8rem",
		marginBottom: "0.5rem",
		fontWeight: "700",
		textTransform: "uppercase",
		color: "#339933",
	},
});

const Void = () => {
	const classes = useStyles();
	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	// useEffect(() => { //
	// 	getPaymentList();
	// }, []);

	const [selectedDate, setSelectedDate] = React.useState(new Date());
	// const [payments, setPayments] = useState([]);
	const [branchIdNo, setBranchIdNo] = useState(get_cookies('branchidno'));
	//state for disabling/enabling button
	const [btnDisabled, setBtnDisabled] = useState(true);

	const [refNo, setRefNo] = useState('');
	const [reason, setReason] = useState('');
	const [type, setType] = useState('');

	const [showMsgBox, setShowMsgBox] = useState(false);
    const [msgBoxContent, setMsg] = useState("Empty");
    const [msgType, setMsgType] = useState("success");
	const [showModal, setShowModal] = useState(false);
	const [voidData, setVoidData] = useState([]);

	const [showSecondPage, setShowSecondPage] = useState(false);

	let history = useHistory();
	
	const types = [
		{label:"CASH VOUCHER",description:"CASH VOUCHER"},
		{label:"CHECK",description:"CHECK"},
		{label:"COLLECTION",description:"COLLECTION"},
		{label:"GL TRANSACTION",description:"GL"},
		{label:"INVENTORY ADJUSTMENT",description:"INVENTORY ADJUSTMENT"},
		// {label:"PACKAGE PURCHASE",description:"PACKPURCHASE"},
		{label:"PACKAGE SALES",description:"PACKSALES"},
		{label:"WHOLESALE SET",description:"WHOLESALES"},
		{label:"PURCHASE ORDER RETURN",description:"PO RETURN"},
		{label:"PURCHASE ORDER",description:"PO"},
		{label:"SALES ORDER",description:"SO"},
		{label:"SALES ORDER RETURN",description:"SALES RETURN"},
	]

	const selectTypeProps = {
		options: types,
		getOptionLabel: (option) => option.label,
	};


	const handleDateChange = (date) => {
		setSelectedDate(date);
	};

	// refno:72
	// datatype:SALES RETURN
	// reason:wala lang
	// jc_u_idno:DAVAOHQ
	useEffect(() => {
		if(refNo&&reason&&type) {
			setBtnDisabled(false); // re-enable
		}else{
			setBtnDisabled(true); // re-enable	
		}
	}, [refNo,reason,type]);

	const get_void_record  = async () => {		
		setBtnDisabled(true); 		
		setShowModal(true); //hide loading/please wait modal
		await axios.get(process.env.REACT_APP_API_URL+'/get_record_to_void', {
			params:{
				refno:refNo,
				datatype:type,
				reason:reason,
				jc_u_idno: get_cookies('branchidno'),  //branchIdNo
			}
		}).then((res)=>{
			const void_data = res.data.data;
			if(void_data.voidable){ //true{
				// console.log(void_data);
				setVoidData(res.data.data);
				setShowModal(false); //hide loading/please wait modal
				setShowSecondPage(true);
				setBtnDisabled(false); 	
				//show 2nd page (form to press the void button) + details of module to void
			}else{
				setShowModal(false); //hide loading/please wait modal
				setShowMsgBox(true);
				setMsg(void_data.message);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
				}, 2500)
			}
		}).catch((error)=>{
			setShowModal(false); //hide loading/please wait modal
			setShowMsgBox(true);
			setMsg("Something went wrong: "+error.message);
			setMsgType("warning");
			setTimeout(() => {
				setShowMsgBox(false);
				setBtnDisabled(false); // re-enable
			}, 2500)
		});
	};
	// jc_uname:superuser
	// jc_u_idno:DAVAOHQ
	// datatype:SALES RETURN
	// reason:SKRRRRAAAAAAAAAAAAAAAAAAAAAAAAAAAA
	// refno:72
	const void_record = async () => {
		setBtnDisabled(true); // disable button to avoid multiple saves
		setShowModal(true);
		const formData = new FormData();
		formData.append("jc_uname", get_cookies('username'));
		formData.append("jc_u_idno", get_cookies('branchidno'));
		formData.append("datatype", type);
		formData.append("reason", reason);
		formData.append("refno", refNo);
		formData.append("curcode", get_cookies('curcode')); //curcode only needed by voiding collection
			//show 3rd ui, sales order payment
			await axios.post(process.env.REACT_APP_API_URL+'void_record', formData, {
				headers: {
					'Content-Type': 'multipart/form-data'
					}
			}).then(function (res) {
				setShowModal(false); //hide loading/please wait modal
				setShowMsgBox(true);
				setMsg("Successfully voided "+type + " #"+refNo);
				setMsgType("success");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
					history.push('/settings');
				}, 2000)
		  	}).catch(function (error) {
				setShowModal(false); //hide loading/please wait modal 
				setShowMsgBox(true);
				setMsg("Something went wrong: "+error);
				setMsgType("warning");
				setTimeout(() => {
					setShowMsgBox(false);
					setBtnDisabled(false); // re-enable
				}, 2500)
	  		});
	}

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				<Breadcrumbs aria-label="breadcrumb">
					<NavLink to="/settings">
						<h2 className="header-title">Settings</h2>
					</NavLink>
					<Typography color="textPrimary">Void</Typography>
				</Breadcrumbs>
			</div>

			{/* 1st page - finding record to void*/}
			{!showSecondPage ? (
			<Slide direction="right" in={!showSecondPage} mountOnEnter unmountOnExit>	
				<div className="page-container">
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				<Card className={classes.card}>
					<LoadingModal showModal={showModal}/>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={8}>
								<div className={classes.title}>
								Voiding Form
								</div>
							</Grid>
							<Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>
							</Grid>
							<Grid
							
								item
								xs={2}
								className={classes.buttonContainer}
							>
							</Grid>
							<Grid container spacing={2}>
								<Grid item xs="12" sm="6" lg="4" xl="3">
									<form noValidate autoComplete="off">
										<TextField
											id="outlined-basic"
											label="Reference No."
											variant="outlined"
											type="text"
											style={{marginTop:"2rem"}}
											className={classes.field}
											value={refNo} 
											onChange={(e)=>{setRefNo(e.target.value)}}
										/>
										<Autocomplete
											{...selectTypeProps}
											id="auto-complete-1"
											autoComplete
											style={{marginBottom:"1rem"}}
											includeInputInList
											renderInput={(params) => (
												<TextField
													{...params}
													label="Type"
													variant="outlined"
												/>
											)}onChange={(event, newValue) => {
												if (!newValue == "" || !newValue == null){
													//console.log(newValue.description);
													setType(newValue.description);
												}
											}}
										/>
									<TextField
											id="outlined-basic"
											label="Reason"
											variant="outlined"
											type="text"
											className={classes.field}
											value={reason} 
											onChange={(e)=>{setReason(e.target.value)}}
										/>
											</form>
							</Grid>
					        </Grid>
						</Grid>
					</div>	
				</Card>				
					<div className={classes.buttonContainer}>
						<Button disabled={btnDisabled} onClick={get_void_record} variant="contained" color="primary">
							Search Record
						</Button>
					</div>
				</div>
			</Slide>) : (<></>) }

			{/* 2nd page - voiding*/}
			{showSecondPage ? (
			<Slide direction="right" in={showSecondPage} mountOnEnter unmountOnExit>
				<div className="page-container">
				<MessageBox in={showMsgBox} content={msgBoxContent} type={msgType}/>
				<Card className={classes.card}>
					<LoadingModal showModal={showModal}/>
					<div className={classes.cardHeader}>
						<Grid container spacing={0} style={{justifyContent: "flex-end"}}>
							<Grid item xs={8}>
								<div className={classes.subTitle}>
								Void Record
								</div>
								<div className={classes.title}>
								Void Record
								</div>
							</Grid>
							<Grid
								item
								xs={2}
								style={{textAlign: "right"}}
							>
							</Grid>
							<Grid
								item
								xs={2}
								className={classes.buttonContainer}
							>
							</Grid>
							<Grid container spacing={2}>

								{type==='CASH VOUCHER' ? (<>
									<Grid item xs="6" lg="5" xl="4">
									<form noValidate autoComplete="off">
										<TextField
											id="outlined-basic"
											label="Actual Amount"
											variant="outlined"
											type="text"
											fullWidth={true}
											style={{marginTop:"2rem"}}
											className={classes.field}
											value={voidData.actual_amount} 
											InputProps={{
												readOnly: true,
											  }}
										/>
										<TextField
											id="outlined-basic"
											label="Amount"
											variant="outlined"
											type="text"
											fullWidth={true}
											className={classes.field}
											value={voidData.amount} 
											InputProps={{
												readOnly: true,
											  }}
										/>
										<TextField
											id="outlined-basic"
											label="CV No"
											variant="outlined"
											type="text"
											fullWidth={true}
											className={classes.field}
											value={voidData.cv_no} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
											id="outlined-basic"
											label="Date"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.date} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
											id="outlined-basic"
											label="Fund From"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.fund_from} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
										id="outlined-basic"
										label="name"
										variant="outlined"
										type="text"
										className={classes.field}
										value={voidData.name} 
										InputProps={{
											readOnly: true,
										  }}
									/>
									<TextField
										id="outlined-basic"
										label="notes"
										variant="outlined"
										type="text"
										className={classes.field}
										value={voidData.notes} 
										InputProps={{
											readOnly: true,
										  }}
									/>
									</form>
								</Grid>
								</>) : (<></>)}

								{type==='CHECK' ? (<>
									<Grid item xs="6" lg="5" xl="4">
									<form noValidate autoComplete="off">
										<TextField
											id="outlined-basic"
											label="Allocation"
											variant="outlined"
											type="text"
											fullWidth={true}
											style={{marginTop:"2rem"}}
											className={classes.field}
											value={voidData.allocation} 
											InputProps={{
												readOnly: true,
											  }}
										/>
										<TextField
											id="outlined-basic"
											label="Amount"
											variant="outlined"
											type="text"
											fullWidth={true}
											className={classes.field}
											value={voidData.amount} 
											InputProps={{
												readOnly: true,
											  }}
										/>
										<TextField
											id="outlined-basic"
											label="Cleared"
											variant="outlined"
											type="text"
											fullWidth={true}
											className={classes.field}
											value={voidData.cleared} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
											id="outlined-basic"
											label="Date"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.date} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
											id="outlined-basic"
											label="Pay To"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.pay_to} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
										id="outlined-basic"
										label="Type"
										variant="outlined"
										type="text"
										className={classes.field}
										value={voidData.type} 
										InputProps={{
											readOnly: true,
										  }}
									/>
									</form>
								</Grid>
								</>) : (<></>)}

								{type==='COLLECTION' ? (<>
									<Grid item xs="6" lg="5" xl="4">
									<form noValidate autoComplete="off">
										<TextField
											id="outlined-basic"
											label="Name"
											variant="outlined"
											type="text"
											fullWidth={true}
											style={{marginTop:"2rem"}}
											className={classes.field}
											value={voidData.name} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
											id="outlined-basic"
											label="Date"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.date} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
											id="outlined-basic"
											label="Type"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.type} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
										id="outlined-basic"
										label="Reference"
										variant="outlined"
										type="text"
										className={classes.field}
										value={voidData.reference} 
										InputProps={{
											readOnly: true,
										  }}
									/>
									<TextField
										id="outlined-basic"
										label="Amount"
										variant="outlined"
										type="text"
										className={classes.field}
										value={voidData.amount} 
										InputProps={{
											readOnly: true,
										  }}
									/>
									</form>
								</Grid>
								</>) : (<></>)}

								{type==='GL' ? (<>
									<Grid item xs="6" lg="5" xl="4">
									<form noValidate autoComplete="off">
										<TextField
											id="outlined-basic"
											label="Amount"
											variant="outlined"
											type="text"
											fullWidth={true}
											style={{marginTop:"2rem"}}
											className={classes.field}
											value={voidData.amount} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
											id="outlined-basic"
											label="Date"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.date} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
											id="outlined-basic"
											label="GL No"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.gl_no} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
										id="outlined-basic"
										label="Type"
										variant="outlined"
										type="text"
										className={classes.field}
										value={voidData.type} 
										InputProps={{
											readOnly: true,
										  }}
									/>
									</form>
								</Grid>
								</>) : (<></>)}

								{type==='INVENTORY ADJUSTMENT' ? (<>
									<Grid item xs="6" lg="5" xl="4">
									<form noValidate autoComplete="off">
										<TextField
											id="outlined-basic"
											label="Adj No"
											variant="outlined"
											type="text"
											fullWidth={true}
											style={{marginTop:"2rem"}}
											className={classes.field}
											value={voidData.adj_no} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
											id="outlined-basic"
											label="Date"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.date} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
											id="outlined-basic"
											label="Location"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.location} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
										id="outlined-basic"
										label="Type"
										variant="outlined"
										type="text"
										className={classes.field}
										value={voidData.type} 
										InputProps={{
											readOnly: true,
										  }}
									/>
									</form>
								</Grid>
								</>) : (<></>)}

								{type==='PO' ? (<>
									<Grid item xs="6" lg="5" xl="4">
									<form noValidate autoComplete="off">
										<TextField
											id="outlined-basic"
											label="DR Amount"
											variant="outlined"
											type="text"
											fullWidth={true}
											style={{marginTop:"2rem"}}
											className={classes.field}
											value={voidData.dr_amount} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
											id="outlined-basic"
											label="Name"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.name} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
											id="outlined-basic"
											label="PO Date"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.po_date} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
										id="outlined-basic"
										label="PO No"
										variant="outlined"
										type="text"
										className={classes.field}
										value={voidData.po_no} 
										InputProps={{
											readOnly: true,
										  }}
									/>
									</form>
								</Grid>
								</>) : (<></>)}
					        
								{type==='PO RETURN' ? (<>
									<Grid item xs="6" lg="5" xl="4">
									<form noValidate autoComplete="off">
										<TextField
											id="outlined-basic"
											label="Amount"
											variant="outlined"
											type="text"
											fullWidth={true}
											style={{marginTop:"2rem"}}
											className={classes.field}
											value={voidData.amount} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
											id="outlined-basic"
											label="Date"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.date} 
											InputProps={{
												readOnly: true,
											  }}
									/>
									<TextField
											id="outlined-basic"
											label="Name"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.name} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
											id="outlined-basic"
											label="Po Return No"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.reference} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									{/* <TextField
										id="outlined-basic"
										label="SO No"
										variant="outlined"
										type="text"
										className={classes.field}
										value={voidData.sales_return_no} 
										InputProps={{
											readOnly: true,
										  }}
									/> */}
									</form>
								</Grid>
								</>) : (<></>)}
							
								{type==='SALES RETURN' ? (<>
									<Grid item xs="6" lg="5" xl="4">
									<form noValidate autoComplete="off">
										<TextField
											id="outlined-basic"
											label="Amount"
											variant="outlined"
											type="text"
											fullWidth={true}
											style={{marginTop:"2rem"}}
											className={classes.field}
											value={voidData.amount} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
											id="outlined-basic"
											label="Date"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.date} 
											InputProps={{
												readOnly: true,
											  }}
									/>
									<TextField
											id="outlined-basic"
											label="Name"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.name} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
											id="outlined-basic"
											label="Sales Return No"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.sales_return_no} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									</form>
								</Grid>
								</>) : (<></>)}

								{type==='SO' ? (<>
									<Grid item xs="6" lg="5" xl="4">
									<form noValidate autoComplete="off">
										<TextField
											id="outlined-basic"
											label="Amount"
											variant="outlined"
											type="text"
											fullWidth={true}
											style={{marginTop:"2rem"}}
											className={classes.field}
											value={voidData.amount} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
											id="outlined-basic"
											label="Date"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.date} 
											InputProps={{
												readOnly: true,
											  }}
									/>
									<TextField
											id="outlined-basic"
											label="Name"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.name} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
											id="outlined-basic"
											label="Sales Order No"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.sono} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									</form>
								</Grid>
								</>) : (<></>)}

								{type==='PACKSALES' ? (<>
									<Grid item xs="6" lg="5" xl="4">
									<form noValidate autoComplete="off">
										<TextField
											id="outlined-basic"
											label="Package Amount"
											variant="outlined"
											type="text"
											fullWidth={true}
											style={{marginTop:"2rem"}}
											className={classes.field}
											value={voidData.package_amount} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
											id="outlined-basic"
											label="Date"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.date} 
											InputProps={{
												readOnly: true,
											  }}
									/>
									<TextField
											id="outlined-basic"
											label="Sold To"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.sold_to} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
											id="outlined-basic"
											label="ID No"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.id_no} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
											id="outlined-basic"
											label="Type"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.type} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									</form>
								</Grid>
								</>) : (<></>)}
								{type==='WHOLESALES' ? (<>
									<Grid item xs="6" lg="5" xl="4">
									<form noValidate autoComplete="off">
										<TextField
											id="outlined-basic"
											label="Package Amount"
											variant="outlined"
											type="text"
											fullWidth={true}
											style={{marginTop:"2rem"}}
											className={classes.field}
											value={voidData.package_amount} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
											id="outlined-basic"
											label="Date"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.date} 
											InputProps={{
												readOnly: true,
											  }}
									/>
									<TextField
											id="outlined-basic"
											label="Sold To"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.sold_to} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
											id="outlined-basic"
											label="ID No"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.id_no} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									<TextField
											id="outlined-basic"
											label="Type"
											variant="outlined"
											type="text"
											className={classes.field}
											value={voidData.type} 
											InputProps={{
												readOnly: true,
											  }}
										/>
									</form>
								</Grid>
								</>) : (<></>)}

							</Grid>
							</Grid>
					</div>	
				</Card>				
					<div className={classes.buttonContainer}>
						<Button onClick={void_record} variant="contained" color="primary">
							Void Record
						</Button>
						<Button onClick={()=>{setShowSecondPage(false)}} style={{marginLeft:"0.5rem"}}variant="contained" color="primary">
							Back
						</Button>
					</div>
				</div>
			</Slide>) : (<></>) }

		</div>
	);
};


export default Void;
